module.exports = __webpack_public_path__ + "static/media/flatcolours-bg.7e709208.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/flatcolours-bg.png
// module id = 126
// module chunks = 0